var map = {
	"./alipay.svg": 1971,
	"./hot.svg": 1542,
	"./national/Africa.svg": 1244,
	"./national/Albania.svg": 8918,
	"./national/Algeria.svg": 2347,
	"./national/America.svg": 2350,
	"./national/Americas.svg": 3345,
	"./national/Anguilla.svg": 1761,
	"./national/Antigua-Barbuda.svg": 8569,
	"./national/Argentina.svg": 2821,
	"./national/Armenia.svg": 1475,
	"./national/Asia.svg": 7380,
	"./national/Australia.svg": 4996,
	"./national/Austria.svg": 6863,
	"./national/Azerbaijan.svg": 4705,
	"./national/Bangladesh.svg": 5429,
	"./national/Barbados.svg": 8752,
	"./national/Belarus.svg": 9802,
	"./national/Belgium.svg": 3873,
	"./national/Bermuda.svg": 4446,
	"./national/Bosnia-Herzegovina.svg": 2317,
	"./national/Brazil.svg": 8120,
	"./national/BritishVirginIsland.svg": 9519,
	"./national/Brunei.svg": 3569,
	"./national/Bulgaria.svg": 5721,
	"./national/CIvoire.svg": 887,
	"./national/Cambodia.svg": 968,
	"./national/Cameroon.svg": 7278,
	"./national/Canada.svg": 6940,
	"./national/Cayman Islands.svg": 335,
	"./national/CentralAfrican.svg": 7047,
	"./national/Chile.svg": 1281,
	"./national/China.svg": 9275,
	"./national/Colombia.svg": 1508,
	"./national/Congo-Brazzaville.svg": 4769,
	"./national/Congo-Kinshasa.svg": 2253,
	"./national/CostaRica.svg": 1397,
	"./national/Croatia.svg": 225,
	"./national/Cyprus.svg": 7204,
	"./national/CzechRepublic.svg": 2079,
	"./national/Denmark.svg": 8508,
	"./national/Dominica.svg": 8712,
	"./national/DominicanRepublic.svg": 2614,
	"./national/Ecuador.svg": 9911,
	"./national/Egypt.svg": 59,
	"./national/El Salvador.svg": 6917,
	"./national/Estonia.svg": 2839,
	"./national/Europe.svg": 3780,
	"./national/FaroeIslands.svg": 4541,
	"./national/Fiji.svg": 9110,
	"./national/Finland.svg": 7538,
	"./national/France.svg": 8207,
	"./national/FrenchGuiana.svg": 1543,
	"./national/Georgia.svg": 5390,
	"./national/Germany.svg": 353,
	"./national/Ghana.svg": 8903,
	"./national/Gibraltar.svg": 9574,
	"./national/Greece.svg": 4195,
	"./national/Grenada.svg": 9772,
	"./national/Guam.svg": 6120,
	"./national/Guatemala.svg": 4121,
	"./national/Haiti.svg": 7945,
	"./national/Honduras.svg": 1746,
	"./national/Hongkong.svg": 9779,
	"./national/Hungary.svg": 3284,
	"./national/Iceland.svg": 9632,
	"./national/India.svg": 2135,
	"./national/Indonesia.svg": 1844,
	"./national/Iran.svg": 9494,
	"./national/Ireland.svg": 243,
	"./national/Israel.svg": 9762,
	"./national/Italy.svg": 7235,
	"./national/Jamaica.svg": 2432,
	"./national/Japan.svg": 7710,
	"./national/Jordan.svg": 6464,
	"./national/Kazakhstan.svg": 9504,
	"./national/Kenya.svg": 9998,
	"./national/Kuwait.svg": 7669,
	"./national/Kyrgyzstan.svg": 1166,
	"./national/Laos.svg": 6961,
	"./national/Latvia.svg": 1959,
	"./national/Lesotho.svg": 5700,
	"./national/Liberia.svg": 2912,
	"./national/Lithuania.svg": 9451,
	"./national/Luxembourg.svg": 4850,
	"./national/Macau.svg": 2001,
	"./national/Madagascar.svg": 5494,
	"./national/Malawi.svg": 157,
	"./national/Malaysia.svg": 9595,
	"./national/Malta.svg": 5461,
	"./national/Martinique.svg": 2731,
	"./national/Mauritius.svg": 9867,
	"./national/Mexico.svg": 9671,
	"./national/Moldova.svg": 3102,
	"./national/Mongolia.svg": 2420,
	"./national/Montenegro.svg": 2476,
	"./national/Morocco.svg": 5488,
	"./national/Mozambique.svg": 4496,
	"./national/Myanmar.svg": 9379,
	"./national/Nepal.svg": 9556,
	"./national/Netherlands.svg": 3845,
	"./national/NewZealand.svg": 7995,
	"./national/Nicaragua.svg": 423,
	"./national/Nigeria.svg": 3123,
	"./national/Norway.svg": 304,
	"./national/Oceania.svg": 5426,
	"./national/Oman.svg": 4635,
	"./national/Pakistan.svg": 7723,
	"./national/Panama.svg": 950,
	"./national/PapuaGuinea.svg": 8228,
	"./national/Paraguay.svg": 4654,
	"./national/Peru.svg": 7812,
	"./national/Philippines.svg": 7907,
	"./national/Poland.svg": 6426,
	"./national/Portugal.svg": 6192,
	"./national/Qatar.svg": 3658,
	"./national/Reunion.svg": 8970,
	"./national/Romania.svg": 675,
	"./national/RussianFederation.svg": 9446,
	"./national/Rwanda.svg": 1863,
	"./national/Saint Lucia.svg": 1191,
	"./national/SaintKittsNevis.svg": 3103,
	"./national/SaintVincentGrenadines.svg": 6590,
	"./national/SaudiArabia.svg": 2676,
	"./national/Serbia.svg": 6524,
	"./national/Seychelles.svg": 2675,
	"./national/SierraLeone.svg": 4563,
	"./national/Singapore.svg": 5148,
	"./national/Slovakia.svg": 6922,
	"./national/Slovenia.svg": 2959,
	"./national/SouthAfrica.svg": 2895,
	"./national/SouthKorea.svg": 1941,
	"./national/Spain.svg": 4221,
	"./national/SriLanka.svg": 9279,
	"./national/Sudan.svg": 8791,
	"./national/Swaziland.svg": 3545,
	"./national/Sweden.svg": 6086,
	"./national/Switzerland.svg": 2649,
	"./national/Taiwan.svg": 6234,
	"./national/Tajikistan.svg": 5796,
	"./national/Tanzania.svg": 628,
	"./national/Thailand.svg": 2619,
	"./national/Tonga.svg": 7813,
	"./national/TrinidadTobago.svg": 2939,
	"./national/Tunisia.svg": 9729,
	"./national/Turkey.svg": 5476,
	"./national/TurksCaicos.svg": 875,
	"./national/UAE.svg": 6529,
	"./national/Uganda.svg": 2014,
	"./national/Ukraine.svg": 4141,
	"./national/UnitedKingdom.svg": 9894,
	"./national/Uruguay.svg": 130,
	"./national/Uzbekistan.svg": 1548,
	"./national/Vanuatu.svg": 7042,
	"./national/Vitenam.svg": 7872,
	"./national/Yemen.svg": 9676,
	"./national/Zambia.svg": 7570,
	"./national/european.svg": 401,
	"./national/hmt.svg": 4429,
	"./national/korea-circle.svg": 5737,
	"./national/lebanon-circle.svg": 8282,
	"./national/usa-circle.svg": 5976,
	"./national/word.svg": 4954,
	"./paypal.svg": 1036,
	"./sa.svg": 2369,
	"./stripe.svg": 9558,
	"./wxpay.svg": 3518
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1525;